import TypeWriter from "./TypeWriter";

export default TypeWriter;
